import { render, staticRenderFns } from "./SummaryROB.vue?vue&type=template&id=12376b80&"
import script from "./SummaryROB.vue?vue&type=script&lang=js&"
export * from "./SummaryROB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports